angular.module('app').controller('AnalyticsCtrl', ["$scope", "$rootScope", "$state", "Server", "ToasterService", "overlaySpinner", "Onboarding", "Translate", "$timeout", "multiSelect", "dateRangePicker", "Util", "$q", "$filter", "$http", function ($scope, $rootScope, $state, Server, ToasterService, overlaySpinner, Onboarding, Translate, $timeout, multiSelect, dateRangePicker, Util, $q, $filter, $http) {
  let multiSelectCampaign = JSON.parse(JSON.stringify(multiSelect))
  let multiSelectBranding = JSON.parse(JSON.stringify(multiSelect))
  let multiSelectDepartment = JSON.parse(JSON.stringify(multiSelect))
  let multiSelectStatus = JSON.parse(JSON.stringify(multiSelect))
  let multiSelectSource = JSON.parse(JSON.stringify(multiSelect))
  let multiSelectLn = JSON.parse(JSON.stringify(multiSelect))
  let multiSelectTags = JSON.parse(JSON.stringify(multiSelect))
  let multiSelectStages = JSON.parse(JSON.stringify(multiSelect))
  let multiSelectCreators = JSON.parse(JSON.stringify(multiSelect))
  let multiSelectHasVideoAnswer = JSON.parse(JSON.stringify(multiSelect))
  $rootScope.validateUserAccess((user, isAsync) => {
    if (!$rootScope.fns.hasPrivileges(['hasAnalytics'], user)) {
        $rootScope.upgradePlan('upgrd_analytics', { backOnClose: true })
    }
    if (!$rootScope.fns.userHasRights('statistics.list', 'view', user)) {
      $state.go('campaigns');
    }
    $scope.multiselectReadyToBuild = true;
    setMultiselectTexts($scope);
  });

  Util.setPageTitle(Translate.getLangString('analytics'));
  $rootScope.secondaryNav = null;
  $rootScope.backEnabled = true;

  $scope.filters = {
      startDate: undefined,
      endDate: undefined,
      brandings: [],
      departments: [],
      status: [],
      campaigns: [],
      referralSources: [],
      language: [],
      tags: [],
      creators: [],
      stages: [],
      hasVideoAnswer: [],
  };
  $scope.initialAnalyticsLoad = true;
  $scope.analyticsBusyLoading = false;
  $scope.allMyBrandings = [];
  $scope.allMyCampaigns = [];
  $scope.filteredCampaigns = [];
  $scope.allMyDepartments = [];
  $scope.allMyReferralSources = [];
  $scope.allLanguages = [];
  $scope.tagOptions = [];
  $scope.creatorsOptions = [];
  $scope.stagesOptions = [];
  $scope.hasVideoAnswerOptions = [];

  $scope.multiSelectBrandingSettings = multiSelectBranding.objectSettings;
  $scope.multiSelectBrandingEvents = { onSelectionChanged: filterCampaigns };
  $scope.multiSelectDepartmentSettings = { ...multiSelectDepartment.objectSettings, displayProp: "name" };
  $scope.multiSelectDepartmentEvents = { onSelectionChanged: filterCampaigns };
  $scope.multiSelectStatusSettings = {
    ...multiSelectStatus.objectSettings,
    showCheckAll: false,
    showUncheckAll: false,
  };
  $scope.multiSelectStagesSettings = multiSelectStages.objectSettings;
  $scope.multiSelectHasVideoAnswerSettings = multiSelectHasVideoAnswer.objectSettings;
  $scope.multiSelectStagesEvents = { onSelectionChanged: reloadCandidates };
  $scope.multiSelectStatusEvents = { onSelectionChanged: filterCampaigns };
  $scope.multiSelectCampaignSettings = multiSelectCampaign.objectSettings;
  $scope.multiSelectCampaignEvents = { onSelectionChanged: reloadCandidates };
  $scope.multiSelectRefSourceSettings = multiSelectSource.objectSettings;
  $scope.multiSelectRefSourceEvents = { onSelectionChanged: reloadCandidates };
  $scope.multiselectSettingsln = multiSelectSource.objectSettings;
  $scope.multiSelectLnEvents = { onSelectionChanged: reloadCandidates };
  $scope.multiSelectTagsSettings = multiSelectTags.objectSettings;
  $scope.multiSelectTagsSettings.template = multiSelect.optionsTemplates.tagsWithCategories;
  $scope.multiSelectTagsSettings.selectedToTop = true;
  $scope.multiSelectTagsSettings.searchField = 'text';
  $scope.multiSelectCreatorsSettings = multiSelectCreators.objectSettings;
  $scope.multiSelectCreatorsEvents = { onSelectionChanged: reloadCandidates };
  $scope.multiSelectHasVideoAnswerEvents = { onSelectionChanged: reloadCandidates };

  $scope.multiSelectTagsEvents = { onSelectionChanged: reloadCandidates };

  $scope.filteredCandidates = [];
  $scope.allMyCampaignschart = [];
  $scope.campaignsIdToLabelMap = {};

  $scope.totalCandidates = 0;
  $scope.numberOfActiveCampaigns = 0;
  $scope.numberOfArchivedCampaigns = 0;
  $scope.meanCandidatePerCampaign = 0;
  $scope.meanInterviewedPerCampaign = 0;

  $scope.backendTimelineData = [];
  $scope.backendReferralData = [];

  $scope.statusOptions = [
    { id: true, label: Translate.getLangString("campaign_filter_active") },
    { id: false, label: Translate.getLangString("campaign_filter_not_active") }
  ];
  $scope.filters.status = [ ...$scope.statusOptions ];

  function setMultiselectTexts(scope) {
    scope.multiSelectBrandingTexts = { ...multiSelectBranding.texts, buttonDefaultText: Translate.getLangString('brand') };
    scope.multiSelectDepartmentTexts = { ...multiSelectDepartment.texts, buttonDefaultText: Translate.getLangString('department') };
    scope.multiSelectStatusTexts = { ...multiSelectStatus.texts, buttonDefaultText: Translate.getLangString('status') };
    scope.multiSelectCampaignTexts = { ...multiSelectCampaign.texts, buttonDefaultText: Translate.getLangString('candidates_select_campaign') };
    scope.multiSelectRefSourceTexts = { ...multiSelectSource.texts, buttonDefaultText: Translate.getLangString('referral_source') };
    scope.multiselectTextsln = { ...multiSelectLn.texts, buttonDefaultText: Translate.getLangString('language') };
    scope.multiSelectTagsTexts = { ...multiSelectTags.texts, buttonDefaultText: Translate.getLangString('tags') };
    scope.multiSelectCreatorsTexts = { ...multiSelectCreators.texts, buttonDefaultText: Translate.getLangString('creator') };
    scope.multiSelectStagesTexts = { ...multiSelectStages.texts, buttonDefaultText: Translate.getLangString('user_rights_candidateStages') };
    scope.multiSelectHasVideoAnswerTexts = { ...multiSelectHasVideoAnswer.texts, buttonDefaultText: Translate.getLangString('video_answer') };
  }

  function loadCampaignStats() {
    return $http.get('/analytics/campaignStats')
      .then(function(response) {
        $timeout(function() {
            const stats = response.data;
            $scope.numberOfActiveCampaigns = stats.activeCampaigns || 0;
            $scope.numberOfArchivedCampaigns = stats.pausedCampaigns || 0;
            $scope.meanCandidatePerCampaign = (stats.averageCandidatesPerCampaign || 0).toFixed(1);
            if ($scope.meanCandidatePerCampaign >= 10) {
                $scope.meanCandidatePerCampaign = Number($scope.meanCandidatePerCampaign).toFixed(0);
            }
            $scope.meanInterviewedPerCampaign = (stats.averageInterviewsPerCampaign || 0).toFixed(2);
             if ($scope.meanInterviewedPerCampaign >= 1) {
                $scope.meanInterviewedPerCampaign = Number($scope.meanInterviewedPerCampaign).toFixed(1);
            }
        });
      })
      .catch(function(err) {
        console.error("Error loading campaign stats:", err);
        ToasterService.failure(err, 'load_campaign_stats_error');
        $timeout(function() {
            $scope.numberOfActiveCampaigns = 0;
            $scope.numberOfArchivedCampaigns = 0;
            $scope.meanCandidatePerCampaign = 0;
            $scope.meanInterviewedPerCampaign = 0;
        });
      });
  }

  function loadFilterOptions() {
    return Server.get('analytics/filterOptions')
      .then(function (options) {
        $scope.allMyBrandings = options.brandings || [];
        $scope.allMyDepartments = options.departments || [];
        $scope.allMyCampaigns = options.campaigns || [];
        $scope.allMyReferralSources = options.referralSources || [];
        $scope.allLanguages = options.languages || [];
        $scope.tagOptions = options.tags || [];
        $scope.creatorsOptions = options.creators || [];
        $scope.stagesOptions = options.stages || [];
        $scope.hasVideoAnswerOptions = options.hasVideoAnswerOptions || [];

        $scope.campaignsIdToLabelMap = $scope.allMyCampaigns.reduce((map, campaign) => {
          map[campaign.id] = campaign.label;
          return map;
        }, {});

        filterCampaignsSetScope();
      })
      .catch(function (err) {
        ToasterService.failure(err, "load_filter_options_error");
        $scope.allMyBrandings = [];
        $scope.allMyDepartments = [];
        $scope.allMyCampaigns = [];
        $scope.allMyReferralSources = [];
        $scope.allLanguages = [];
        $scope.tagOptions = [];
        $scope.creatorsOptions = [];
        $scope.stagesOptions = [];
        $scope.hasVideoAnswerOptions = [];
        $scope.campaignsIdToLabelMap = {};
      });
  }

  function downloadCsv(data, name) {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name || `analytics_export_${new Date().toISOString()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }

  function extractCountAndPercent(input) {
    if (typeof input !== 'string') return null;
    const match = input.match(/^(\d+)\s\((\d+(\.\d+)?)%\)$/);
    return match ? { count: match[1], percent: match[2] + "%" } : null;
  }

  function convertJsonToCsv(jsonData) {
    const title = Translate.getLangString('analytics_page_header');
    let csv = title + '\n\n';
    jsonData.forEach(section => {
      csv += section.section + '\n';
      if (section.section === "\n" && section.data.length > 0) {
        const headers = Object.keys(section.data[0]).map(value => `"${value}"`).join(',');
        csv += headers + '\n';
      }
      section.data.forEach(row => {
        if (typeof row === 'object' && !Array.isArray(row) && (!row.label || !row.value)) {
          const values = Object.values(row).map(value => `"${value}"`).join(',');
          csv += values + '\n';
        } else {
          const countPercent = extractCountAndPercent(row.value);
          csv += countPercent ? `"${row.label}",${countPercent.count},${countPercent.percent}\n` : `"${row.label}","${row.value}"\n`;
        }
      });
      csv += '\n';
    });
    return csv;
  }

  $scope.exportData = async function () {
    if ($scope.analyticsBusyLoading || !$scope.candiReferralPie?.data?.rows) {
        // button will be hidden so this shouldn't happen
        return;
    }

    try {
        const overlay = overlaySpinner.show('analyitcs');
        
        const candiReferralPieSources = $scope.candiReferralPie.data.rows.map(s => ({
          label: s.c[0].v.split(' : ')[0],
          value: s.c[0].v.split(' : ')[1]
        }));
        const distributionStages = $filter('filter')($scope.stagesWithCandidateCount, $scope.stageIsAccessible).map(s => ({
          label: s.label[Translate.currentLanguage()],
          value: `${s.candidatesCount} (${s.percentage}%)`
        }));

        const tagsValueById = $scope.tagOptions.reduce((p, c) => ({ ...p, [c.id]: c.label || c.text.split('|')[0] }), {});
        const stageValueById = $scope.stagesOptions.reduce((p, c) => ({ ...p, [c.id]: c.label }), {});
        const referralSourceOptions = $scope.allMyReferralSources.reduce((p, c) => ({ ...p, [c.id]: c.label }), {});
        const addedByOptions = $scope.creatorsOptions.reduce((p, c) => ({ ...p, [c.id]: c.label }), {});

        const exportFilterBody = buildRequestFilter();
        const candidatesForExport = await $http({ method: 'POST', url: '/analytics/allAnalytics?includeCandidates=true', data: exportFilterBody })
                                        .then(res => res.data.candidates || []);

        const candidatesData = candidatesForExport.map(c => ({
          [Translate.getLangString('campaign')]: $scope.campaignsIdToLabelMap[c.campaignId] || c.campaignId,
          [Translate.getLangString('first_name')]: c.firstName || '',
          [Translate.getLangString('last_name')]: c.lastName || '',
          [Translate.getLangString('candidates_sort_by_application_date')]: c.stepStartTime ? new Date(c.stepStartTime).toLocaleDateString() : '',
          [Translate.getLangString('referral_source')]: referralSourceOptions[c.referralSource] || c.referralSource || '',
          [Translate.getLangString('tags')]: c.tags?.map(t => tagsValueById[t] || t).join(', ') || '',
          [Translate.getLangString('status')]: stageValueById[c.stageCurrent?.stage] || '',
          [Translate.getLangString('added_by')]: addedByOptions[c.addedByUserId] || c.addedByUserId || '',
        }));

        const csvData = [
          {
              "section": Translate.getLangString('analytics_campaigns_header'),
              "data": [
                { "label": Translate.getLangString('analytics_campaigns_active'), "value": $scope.numberOfActiveCampaigns },
                { "label": Translate.getLangString('analytics_campaigns_archived'), "value": $scope.numberOfArchivedCampaigns },
                { "label": Translate.getLangString('analytics_campaigns_mean'), "value": $scope.meanCandidatePerCampaign },
                { "label": Translate.getLangString('analytics_interviewed_mean'), "value": $scope.meanInterviewedPerCampaign }
              ]
          },
          {
            "section": Translate.getLangString('filters'),
            "data": [
              { label: $scope.multiSelectCreatorsTexts.buttonDefaultText, value: $scope.filters.creators.map(v => v.label).join(', ') },
              { label: $scope.multiSelectBrandingTexts.buttonDefaultText, value: $scope.filters.brandings.map(v => v.label).join(', ') },
              { label: $scope.multiSelectStatusTexts.buttonDefaultText, value: $scope.filters.status.map(v => v.label).join(', ') },
              { label: $scope.multiSelectCampaignTexts.buttonDefaultText, value: $scope.filters.campaigns.map(v => v.label).join(', ') },
              { label: Translate.getLangString('analytics_date_filter'), value: ($scope.filters.startDate?.toDate()?.toLocaleDateString() && $scope.filters.endDate?.toDate()?.toLocaleDateString()) ? `${$scope.filters.startDate.toDate().toLocaleDateString()} - ${$scope.filters.endDate.toDate().toLocaleDateString()}` : '' },
              { label: $scope.multiSelectRefSourceTexts.buttonDefaultText, value: $scope.filters.referralSources.map(v => v.label).join(', ') },
              { label: $scope.multiSelectTagsTexts.buttonDefaultText, value: $scope.filters.tags.map(v => v.label || v.text.split('|')[0]).join(', ') },
              { label: $scope.multiSelectStagesTexts.buttonDefaultText, value: $scope.filters.stages.map(v => v.label).join(', ') },
              { label: $scope.multiSelectHasVideoAnswerTexts.buttonDefaultText, value: $scope.filters.hasVideoAnswer.map(v => v.label).join(', ') }
            ]
          },
          {
              "section": `${Translate.getLangString('analytics_candidates_header')},${Translate.getLangString('count')},${Translate.getLangString('percent')}`,
              "data": [
                { "label": Translate.getLangString('analytics_total_candidates'), "value": $scope.totalCandidates },
                ...($scope.qualifiedWithCandidateCount?.accessible ? [{ "label": Translate.getLangString('candidate_stage_qualified'), "value": `${$scope.qualifiedWithCandidateCount.candidatesCount} (${$scope.qualifiedWithCandidateCount.percentage}%)` }] : []),
                ...($scope.hiredWithCandidateCount?.accessible ? [{ "label": Translate.getLangString('candidate_stage_hired'), "value": `${$scope.hiredWithCandidateCount.candidatesCount} (${$scope.hiredWithCandidateCount.percentage}%)` }] : []),
                { "label": Translate.getLangString('analytics_recruitment_time'), "value": `${$scope.meanHiringTime} ${Translate.getLangString('days')}` }
              ]
          },
          {
              "section": `${Translate.getLangString('referral_source')},${Translate.getLangString('count')},${Translate.getLangString('percent')}`,
              "data": candiReferralPieSources
          },
          {
              "section": `${Translate.getLangString('analytics_stage_distribution')},${Translate.getLangString('count')},${Translate.getLangString('percent')}`,
              "data": distributionStages
          },
          {
              "section": "\n",
              "data": candidatesData
          }
        ];

        overlay.hide();

        const outputCsv = convertJsonToCsv(csvData);
        downloadCsv(outputCsv);
    } catch (err) {
        console.error("Error preparing export data:", err);
        ToasterService.failure(err, 'export_data_error');
    }
  }

  function filterCampaignsSetScope() {
    $scope.filteredCampaigns = $scope.allMyCampaigns.filter(camp => {
      const brandingCheck = !$scope.filters.brandings.length || $scope.filters.brandings.some(brand =>
        camp.customization?.employerBrandingId === brand.id
      );
      const statusCheck = !$scope.filters.status.length || $scope.filters.status.some(stat => stat.id === camp.isActive);
      const departmentCheck = !$scope.filters.departments.length || $scope.filters.departments.some(filterDept =>
        camp.departmentIds?.includes(filterDept._id)
      );
      return brandingCheck && statusCheck && departmentCheck;
    });
    $scope.filters.campaigns = $scope.filters.campaigns.filter(c =>
      $scope.filteredCampaigns.some(fc => fc.id === c.id)
    );
  }

  function filterCampaigns() {
    filterCampaignsSetScope();
    return reloadCandidates();
  }

  let currentRequest = null;
  function reloadCandidates(overlay2) {
    const overlay = overlay2 ? overlay2 : overlaySpinner.show("cards-overlay-2");
    if (currentRequest?.resolve) {
      currentRequest.resolve('Request cancelled by new request');
    }
    currentRequest = $q.defer();
    $scope.analyticsBusyLoading = true;

    function processAnalyticsData({ stagesWithCandidateCount, meanHiringTime, totalCandidates, timelineData, referralData }) {
      $scope.lang = Translate.currentLanguage();
      $scope.meanHiringTime = (meanHiringTime != null ? meanHiringTime.toFixed(0) : '...');

      $scope.stagesWithCandidateCount = stagesWithCandidateCount || [];
      $scope.totalCandidates = totalCandidates || 0;
      $scope.backendTimelineData = timelineData || [];
      $scope.backendReferralData = referralData || [];

      const totalForPercentage = $scope.totalCandidates;
      $scope.stagesWithCandidateCount.forEach((stage) => {
        stage.percentage = totalForPercentage ? ((stage.candidatesCount * 100) / totalForPercentage).toFixed(1) : 0;
      });

      const maxCandidateCount = _.maxBy($scope.stagesWithCandidateCount, 'candidatesCount');
      const maxPercentStage = maxCandidateCount ? (maxCandidateCount.percentage / 100) : 1;
      $scope.stagesWithCandidateCount.forEach((stage) => {
        stage.customization = {
          ...(stage.customization || {}),
          width: `${(Math.sqrt(stage.percentage / 100) / Math.sqrt(maxPercentStage || 1)) * 100}%`,
        };
      });

      $scope.qualifiedWithCandidateCount = _.find($scope.stagesWithCandidateCount, { key: 'qualified' });
      $scope.hiredWithCandidateCount = _.find($scope.stagesWithCandidateCount, { key: 'hired' });

      $scope.stageIsAccessible = (stage) => stage.accessible;

      initCandidatesTimeLineChart();
      initCandidatesReferralPie();

      filterCampaignsSetScope();
    }

    const filterBody = buildRequestFilter();

    if (!filterBody.campaigns && $scope.allMyCampaigns.length > 0) {
        filterBody.campaigns = _.map($scope.filteredCampaigns, 'id');
    }

    if (!filterBody.campaigns?.length && !$scope.initialAnalyticsLoad) {
      processAnalyticsData({ stagesWithCandidateCount: [], meanHiringTime: 0, totalCandidates: 0, timelineData: [], referralData: [] });
      $scope.analyticsBusyLoading = false;
      overlay.hide();
      return $q.resolve();
    } else {
      $scope.initialAnalyticsLoad = false;
      return $http({
        method: 'POST',
        url: '/analytics/allAnalytics',
        data: filterBody,
        timeout: currentRequest.promise,
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      })
      .then((res) => {
        processAnalyticsData(res.data);
      })
      .catch((error) => {
        if (error.status === -1 || error.xhrStatus === 'timeout' || (typeof error === 'string' && error.includes('cancelled'))) {
          console.log('Analytics request cancelled:', error);
        } else {
          console.error('Error loading analytics data:', error);
          ToasterService.failure(error, 'load_analytics_error');
          processAnalyticsData({ stagesWithCandidateCount: [], meanHiringTime: 0, totalCandidates: 0, timelineData: [], referralData: [] });
        }
      })
      .finally(() => {
        overlay.hide();
        $scope.analyticsBusyLoading = false;
        currentRequest = null;
      });
    }
  }

  function buildRequestFilter() {
      const filterBody = {};
      if ($scope.filters.startDate?.isValid() && $scope.filters.endDate?.isValid()) {
        filterBody.startDate = $scope.filters.startDate.toISOString();
        filterBody.endDate = $scope.filters.endDate.toISOString();
      }
      if ($scope.filters.campaigns?.length) {
        filterBody.campaigns = _.map($scope.filters.campaigns, 'id');
      }
      else if ($scope.filteredCampaigns.length !== $scope.allMyCampaigns.length) {
         filterBody.campaigns = _.map($scope.filteredCampaigns, 'id');
      }
      if ($scope.filters.referralSources?.length) {
        filterBody.referralSources = _.map($scope.filters.referralSources, 'id');
      }
      if ($scope.filters.tags?.length) {
        filterBody.tags = _.map($scope.filters.tags, 'id');
      }
      if ($scope.filters.creators?.length) {
        filterBody.creators = _.map($scope.filters.creators, 'id');
      }
      if ($scope.filters.stages?.length) {
        filterBody.stages = _.map($scope.filters.stages, 'id');
      }
      if ($scope.filters.hasVideoAnswer?.length) {
        filterBody.hasVideoAnswer = _.map($scope.filters.hasVideoAnswer, 'id');
      }
      if ($scope.filters.language?.length) {
          filterBody.language = _.map($scope.filters.language, 'id');
      }

      return filterBody;
  }

  function initCandidatesTimeLineChart() {
      $scope.candiTimeLineChart = { type: "LineChart", displayed: false, data: {}, options: {}, view: {} };
      let rowData = [];
      $scope.backendTimelineData.forEach(item => {
          const monthLabel = moment().month(item._id.month - 1).format('MMM') + " " + moment().year(item._id.year).format('YY');
          rowData.push({ c: [{ v: monthLabel }, { v: item.count }] });
      });
      $scope.candiTimeLineChart.data = {
          cols: [
              { id: "month-id", label: 'Month', type: "string" },
              { id: "total-id", label: Translate.getLangString('analytics_new_candidates'), type: "number" }
          ],
          rows: rowData
      };
      $scope.candiTimeLineChart.options = {
          colors: ['#28bd83', 'lightskyblue'],
          isStacked: "true",
          fill: 20,
          displayExactValues: true,
          legend: { position: 'none' },
          vAxis: { viewWindow: { min: 0 } },
          hAxis: { textStyle: { bold: false } },
      };
      $scope.candiTimeLineChart.view = { columns: [0, 1] };
      $scope.candiTimeLineChart.displayed = true;
  }

  function initCandidatesReferralPie() {
      $scope.candiReferralPie = { type: "PieChart", data: {}, options: {} };
      let rowData = [];
      const total = $scope.backendReferralData.reduce((sum, item) => sum + item.count, 0);
      $scope.backendReferralData.forEach(item => {
          const referralKey = item._id || "unknown";
          const count = item.count;
          const percentage = total > 0 ? ((count * 100) / total).toFixed(1) : 0;
          let referralLabel = (referralKey === "unknown")
              ? (Translate.getLangString('unknown') || "Unknown")
              : (Translate.getLangString('jb_' + referralKey) || referralKey);
          rowData.push({ c: [{ v: `${referralLabel} : ${count} (${percentage}%)` }, { v: count }] });
      });
      $scope.candiReferralPie.data = {
          cols: [
              { id: 't', label: 'Referral Source', type: 'string' },
              { id: 's', label: 'Candidates', type: 'number' }
          ],
          rows: rowData
      };
      $scope.candiReferralPie.options = {
          pieHole: 0.2,
          fontName: 'Gotham Book',
          fontSize: 14,
          height: 220,
          colors: ['#ffc2d1', '#9cadce', '#d4afb9', '#d1cfe2', '#9cadce', '#7ec4cf', '#d3ab9e', '#a7bed3', '#c6e2e9', '#f1ffc4', '#ffcaaf', '#dab894', '#7ec4cf', '#d3ab9e', '#ffee93', '#fcf5c7', '#b5d6d6', '#efcfe3', '#b3dee2', '#ffdab9', '#bde0fe', '#eac9c1', '#d1d1d1', '#abc4ff', '#809bce', '#95b8d1', '#b8e0d2', '#d6eadf', '#eac4d5', '#fff1e6', '#a2d2ff', '#fcf5c7', '#e8dff5'],
          chartArea: { right: 80, width: '190%', height:'85%' }
      };
  }

  const deferLoadFilters = $q.defer();
  const overlay1 = overlaySpinner.show("cards-overlay-1");
  const overlay2 = overlaySpinner.show("cards-overlay-2");

  $q.all([
    loadFilterOptions(),
    loadCampaignStats()
  ]).then(() => {
      overlay1.hide();
      dateRangePicker.initDatePicker($scope.filters, { useLongRange: false }, reloadCandidates);
      reloadCandidates(overlay2);
      deferLoadFilters.resolve();
    })
    .catch(err => {
      console.error("Error during initial data load:", err);
      overlay1.hide();
      overlay2.hide();
      deferLoadFilters.reject(err);
      ToasterService.failure(err, 'initial_load_error');
    });

  Onboarding.initWidget(null);

  return deferLoadFilters.promise;
}]);
